import { React, PT, withRouter, connect } from '@gasbuddy/react';
import { Button } from 'semantic-ui-react';
import { Auth, Nav, BrandTable } from '../../components';
import { Role } from '../../roles';
import { Action } from '../../reducers/actions';

class BrandsPage extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: Action.Poi.BrandsRequested,
      meta: { apiAction: true },
      payload: {
        url: '/poi/brand',
      },
    });
  }

  addBrand = () => {
    const { history } = this.props;
    history.push('/poi/brand');
  };

  render() {
    const { brand } = this.props;
    let content = '';
    const brands = brand.listing || BrandsPage.defaultProps.brand.listing;
    content = (
      <Auth forRoles={[Role.AnyAdmin]}>
        <Nav>
          <Auth forActions={[Role.POI]} hideUnauthorized>
            <Button onClick={this.addBrand}>Create New Brand</Button>
          </Auth>
          <BrandTable brands={brands} />
        </Nav>
      </Auth>
    );
    return content;
  }
}

const mapStateToProps = state => state;

export const Brands = withRouter(connect(mapStateToProps)(BrandsPage));

BrandsPage.defaultProps = {
  brand: {
    loading: true,
    listing: [],
  },
};

BrandsPage.propTypes = {
  dispatch: PT.func.isRequired,
  history: PT.arrayOf(PT.shape).isRequired,
  brand: PT.shape({
    loading: PT.bool,
    listing: PT.arrayOf(PT.shape({
      brand_id: PT.isnumber,
    })),
  }),
};
